import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import markerPath from 'map_marker.svg';
import ActiveMarker from './ActiveMarker';
import WhiteMarker from '../WhiteMarker';

const ListingMarker = ({
  listing,
  changeActiveMarker,
  activeMarker,
  highlighted,
  type,
  white_marker,
}) => {
  return (
    <Fragment>
      {/* eslint-disable-next-line */}
      {activeMarker === listing.id ? (
        <ActiveMarker
          changeActiveMarker={changeActiveMarker}
          listing={listing}
          type="listing"
        />
      ) : white_marker ? (
        <WhiteMarker
          type={type}
          onClick={() => changeActiveMarker(listing.id)}
          icon={listing.category_image_url && listing.category_image_url}
          highlighted={highlighted}
        />
      ) : (
        <button
          aria-label="View Listing"
          name="View Listing"
          className={`listing-marker ${highlighted ? 'highlighted' : ''}`}
          onClick={() => changeActiveMarker(listing.id)}
          type="button"
        >
          <ReactSVG src={markerPath} />
        </button>
      )}
    </Fragment>
  );
};

ListingMarker.propTypes = {
  listing: PropTypes.object.isRequired,
  changeActiveMarker: PropTypes.func.isRequired,
  activeMarker: PropTypes.number,
  highlighted: PropTypes.bool,
  type: PropTypes.string,
  white_marker: PropTypes.bool,
};

export default ListingMarker;
